<template>
    <div class="header">
        <Signin :data_in="{ form1, form2 }">
            <template #form1>
                <b-button pill class="mb-3" variant="primary" block :disabled="form1ButtonDisabled" @click="form1Save()">
                    <b-spinner small class="mr-2" v-if="form1.isSubmitting || form1.isVerifyingOtp"></b-spinner>
                    {{ form1ButtonText }}
                </b-button>
                <p class="text-center">
                    <b-link>
                        <b-button v-b-modal.modal-forget style="background: unset;color: #007ac2;"
                            class="p-0 border-0">忘記密碼</b-button>
                    </b-link>
                </p>
                <p v-show="false" class="text-center" @click="form1Go()">
                    <b-link>詳細資料</b-link>
                </p>
                <hr />
                <!-- <b-button class="mb-3 d-none" variant="outline-primary" block @click="form1Login('fb')">
                    <b-icon-facebook></b-icon-facebook> 使用 Facebook 帳號登錄
                </b-button>
                <b-button class="mb-3" variant="outline-danger" block @click="form1Login('google')">
                    <b-icon-google></b-icon-google> 使用 Google 帳號登錄
                </b-button> -->
            </template>
            <template #form2>
                <b-button @click="form2Save()" pill class="mb-0" type="submit" variant="primary" block>註冊 </b-button>
                <hr />
                <b-form-checkbox id="checkbox-1" name="checkbox-1" v-model="form2.data['if1'].val"
                    :disabled="form2.data['if1'].only">
                    註冊即表示您同意我們的
                    <b-button v-b-modal.modal-privacy style="background: unset;color: #007ac2;"
                        class="p-0 border-0">個資保護政策</b-button>
                </b-form-checkbox>
            </template>
        </Signin>

        <header class="bg-whitezzz" v-bind:class="{ min: isMin }">
            <b-navbar class="append" v-bind:class="{ 'bg-white': navBg }" toggleable="lg" type="light">
                <b-navbar-brand class="logo" to="/">
                    <b-img :src="nav.data['img']" fluid></b-img>
                </b-navbar-brand>
                <b-button class="mobile-camp-button ml-auto mr-2 d-lg-none" variant="primary" pill to="/camps">
                    <b-icon-flag class="mr-1"></b-icon-flag> 營隊
                </b-button>
                <b-navbar-toggle class="mr-3" @click="navBg = !navBg" target="nav-collapse"
                    id="head-nav-toggle"></b-navbar-toggle>
                <b-collapse style="align-items: center;" class="p-3 p-md-0 h-100" id="nav-collapse" is-nav>
                    <b-form-group class="mb-0">
                        <b-input-group class="course-search">
                            <b-form-input id="input-1" v-model="keywords" type="text" placeholder="想學什麼？"
                                required></b-form-input>
                            <b-input-group-append>
                                <b-button variant="primary round-r border-left-0" class="mr-2"
                                    @click="_go('./courses?keywords=' + keywords)">
                                    <b-icon-search></b-icon-search>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-navbar-nav class="px-4">
                        <b-button class="round mr-md-2 px-3 mb-2 text-nowrap mb-sm-0 d-none d-sm-block" variant="primary" pill
                            to="/courses">
                            <b-icon-book class="mr-2"></b-icon-book> 課程
                        </b-button>
                        <b-button class="round mr-md-2 px-3 mb-2 text-nowrap mb-sm-0 d-none d-lg-flex" variant="primary" pill
                            to="/camps">
                            <b-icon-flag class="mr-2"></b-icon-flag> 營隊
                        </b-button>
                        <div v-if="showHeaderHotTags" class="d-flex align-items-center gap-2">
                            <span class="text-nowrap fw-bolder">熱門 : </span>
                            <div class="hot-tags-list">
                            <b-button
                                v-for="tag in filteredHotTags"
                                :key="tag.Id || tag.Name"
                                class="hot-tag-button"
                                @click="goToCoursesByTag(tag)"
                            >
                                #{{ tag.Name }}
                            </b-button>
                        </div>
                        </div>
                    </b-navbar-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="position-relative">
                                <b-button :to="isCampPage ? '/campCart' : '/cart'"
                                    class="round px-3 mr-md-2 mb-2 mb-sm-0 mt-2 mt-sm-0 h-100" variant="primary" pill>
                                    <b-icon-cart></b-icon-cart>
                                </b-button>
                                <b-badge v-if="cartCountsLoaded && totalCartCount > 0" pill variant="danger"
                                    class="camp-cart-badge">
                                    {{ totalCartCount }}
                                </b-badge>
                            </div>
                            <b-button class="round px-3 mr-md-2 text-nowrap mb-2 mb-sm-0 mt-2 mt-sm-0" variant="primary" pill
                                @click="form1Show()">
                                <b-icon-person class="mr-1"></b-icon-person> {{ form1.text }}
                            </b-button>
                        </div>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </header>
        <LoginV1 :data_in="LoginF1" :val="'f'"></LoginV1>
    </div>
</template>
<script>
import axios from 'axios';
import Signin from '@/components/Signin.vue';
import LoginV1 from '../components/LoginV1.vue';
import { apiLogin, apiVerifyMemberTwoFactorLogin, apiResendMemberTwoFactorLogin, apiCheckMember, apiRegister, apiGetCaptcha , apiGetHotTags, } from '@/api/API.js';
export default {
    name: 'page-header',
    components: {
        Signin,
        LoginV1,
    },
    data() {
        return {
            Token: '',
            keywords: '',
            hotTags: [],
            cartSessionKey: '',
            memberOtpCountdownTimer: null,
            navBg: false,
            modal_set: [
                { name: 'form1', id: 'signin' },
                { name: 'form3', id: 'forget' },
            ],

            form1: {
                text: '學員',
                title: '登入',
                show: true,
                url: 'member',
                twoFactorPending: false,
                twoFactorToken: '',
                otpExpireMinutes: 5,
                otpRemainingSeconds: 0,
                otpCountdownText: '05:00',
                otpExpired: false,
                isSubmitting: false,
                isVerifyingOtp: false,
                isResendingOtp: false,
                data: {
                    Id: { type: 'text', val: '', text: '帳號／電子郵件', only: false, msg: '' },
                    DecryptionPass: { type: 'password', val: '', text: '密碼', only: false, msg: '' },
                    CodePass: {
                        type: 'text',
                        val: '',
                        text: '驗證碼',
                        only: false,
                        msg: '',
                        img: { Code: '', Image: '' },
                    },
                    OtpCode: { type: 'text', val: '', text: 'Email 驗證碼', only: false, msg: '' },
                },
            },
            form2: {
                title: '註冊',
                show: false,
                data: {
                    AC_USERNAME: { type: 'text', val: '', text: '姓名', only: false, msg: '' },
                    AC_USERID: { type: 'text', val: '', text: '身分證字號', only: false, msg: '' },
                    AC_BIRTHDAY: { type: 'text', val: '', text: '出生年月日', only: false, msg: '' },
                    AC_EMAIL: { type: 'text', val: '', text: '電子郵件', only: false, msg: '' },
                    AC_TEL: { type: 'text', val: '', text: '行動電話', only: false, msg: '' },
                    AC_PWD: { type: 'password', val: '', text: '密碼', only: false, msg: '' },
                    AC_PWD2: { type: 'password', val: '', text: '確認密碼', only: false, msg: '' },
                    CodePass: {
                        type: 'text',
                        val: '',
                        text: '驗證碼',
                        only: false,
                        msg: '',
                        img: { Code: '', Image: '' },
                    },
                    if1: { val: false, text: '是否同意', only: false },
                },
            },
            form3: {
                title: '忘記密碼',
                data: {
                    Id: {
                        val: '',
                        text: '帳號／電子郵件',
                        only: false,
                        msg: '',
                        keypress: () => { },
                        change: () => { },
                    },
                    AC_EMAIL: {
                        val: '',
                        text: '電子郵件',
                        only: false,
                        msg: '',
                        keypress: () => { },
                        change: () => { },
                    },
                },
            },

            isMin: false,

            nav: {
                show: true,
                title: '搜尋',
                data: {
                    img: require('@/assets/長版LOGO-黑2.png'),
                    val: '',
                },
                options: [],
            },
            LoginF1: {},
            LoginData: {},
            CategoryData: [],
            files: {},
            imageCode: '',
        };
    },
    created() {
        this.Init();
    },
    mounted() {
        const originalForm2Check = this.form2Check.bind(this);
        this.form2Check = (id) => {
            if (id == 'CodePass') {
                let msg = '';
                this.form2.data['CodePass'].msg = '';
                if (this.IsNull(this.form2.data['CodePass'].val) == '') {
                    msg += '未填寫驗證碼\n';
                    this.form2.data['CodePass'].msg = {
                        type: false,
                        texts: ['未填寫驗證碼'],
                    };
                }
                return msg;
            }
            return originalForm2Check(id);
        };
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('pageshow', this.handlePageShow);
        this.$root.$on('bv::modal::hidden', this.handleModalHidden);
        this.modal_init(this.modal_set);
        this.formCheckSet();
        this.LoginData['google'] = this.LoginF1['f'].GoogleModel();
        this.LoginData['fb'] = this.LoginF1['f'].FBModel();

        this._storeData('LoginF1', this.form1Show.bind(this));
        this._storeData('Header_form1', this.form1);
        this._storeData('navBgSwitch', this.navBgSwitch);

        if (this.IsNull(this._sessionData('TokenID')) != '') {
            this.form1.text = '學員資料';
            this.refreshCartCounts();
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('pageshow', this.handlePageShow);
        this.$root.$off('bv::modal::hidden', this.handleModalHidden);
        this.stopMemberOtpCountdown();
        if (this.imageCode) {
            URL.revokeObjectURL(this.imageCode);
        }
    },
    computed: {
        isCampPage() {
            return this.$route.path.startsWith('/camp');
        },
        campCartCount() {
            return this.$store.getters['campCart/totalCount'];
        },
        courseCartCount() {
            return this.$store.state.courseCart.count;
        },
        totalCartCount() {
            return this.campCartCount + this.courseCartCount;
        },
        cartCountsLoaded() {
            return this.$store.state.campCart.loaded && this.$store.state.courseCart.loaded;
        },
        form1ButtonText() {
            if (this.form1.isSubmitting) {
                return '發送驗證碼中...';
            }
            if (this.form1.isVerifyingOtp) {
                return '驗證中...';
            }
            if (this.form1.twoFactorPending) {
                return this.form1.otpExpired ? '驗證碼已過期' : '請輸入驗證碼';
            }
            return '登入';
        },
        form1ButtonDisabled() {
            if (this.form1.isSubmitting || this.form1.isVerifyingOtp) {
                return true;
            }

            if (this.form1.twoFactorPending) {
                if (this.form1.otpExpired) {
                    return true;
                }

                return !String(this.form1.data['OtpCode'].val || '').trim();
            }

            return !String(this.form1.data['Id'].val || '').trim()
                || !String(this.form1.data['DecryptionPass'].val || '').trim()
                || !String(this.form1.data['CodePass'].val || '').trim();
        },
        filteredHotTags() {
            return (this.hotTags || []).filter((tag) => tag && tag.Enable === true && tag.IsHot === true && tag.ShowOn === true);
        },
        showHeaderHotTags() {
            return this.$route.path !== '/courses' && this.$route.path !== '/course' && this.filteredHotTags.length > 0;
        },
    },
    methods: {
        handlePageShow(event) {
            if (event.persisted) {
                this.resetAuthModalState();
            }
        },
        handleModalHidden(bvEvent, modalId) {
            if (modalId !== 'signin') {
                return;
            }

            this.resetAuthModalState();
        },
        resetAuthModalState() {
            this.form1Clear();
            this.form2Clear();
            this.form1.show = true;
            this.form2.show = false;
        },
        Init() {
            apiGetHotTags()
            .then((res) => {
                this.hotTags = Array.isArray(res.data) ? res.data : [];
            })
            .catch(console.log);
        },
        navBgSwitch(val) {
            if (val != this.navBg) {
                document.getElementById('head-nav-toggle').click();
            }
        },
        navKeyOn(event) {
            if (event.charCode === 13) {
                this.navGo();
            }
        },
        sessionF1(url, data) {
            if (url == 'courses') {
                /*
        this._go2({
          path:'/courses',
          data:{CAT_ID:data}
        },'query')
        */
                this._sessionData('CAT_ID', this.IsNull(data.CAT_ID));
                this._sessionData('courseStatus', this.IsNull(data.courseStatus));
                if (this.$route.path !== '/courses') {
                    this._go('/courses');
                } else {
                    this.$router.go();
                }
            } else if (url == 'course') {
                this._go2(
                    {
                        path: '/course',
                        data: { CP_ID: data },
                    },
                    'query',
                );
            } else if (url == 'NewsDetail') {
                this._go2(
                    {
                        path: '/NewsDetail',
                        data: { NE_ID: data },
                    },
                    'query',
                );
            } else if (url == 'courseSeriesDetails') {
                this._go2(
                    {
                        path: '/courseSeriesDetails',
                        data: { SS_ID: data },
                    },
                    'query',
                );
            }
        },
        navGo(data) {
            console.log('header------------');
            console.log(data);
            console.log(this.$route);

            if (this.IsNull(data) != '') {
                this.sessionF1('courses', this.IsNull({ CAT_ID: data.CAT_ID }));
            } else {
                this._storeData('reload', () => {
                    /*
          this._go2({
            path: "/courses",
            data: { keyword: this.IsNull(this.nav.data.val) },
          },"query")
          */
                    this._sessionData('keyword', this.IsNull(this.nav.data.val));
                    this._go('/courses');
                    this.nav.data.val = '';
                });
                this._go('Reload');
            }

            //
        },
        goToCoursesByTag(tag) {
            if (!tag || !tag.Name) {
                return;
            }

            this.$router.push({
                name: 'courses',
                query: {
                    tag: tag.Name,
                },
            });
        },
        formCheckSet() {
            const navForm = document.getElementById('navForm1');
            if (navForm) {
                navForm.onsubmit = () => false;
            }

            for (let i in this.form1.data) {
                let item = this.form1.data[i];
                item.change = () => {
                    this.form1Check(i);
                };
            }
            for (let i in this.form2.data) {
                let item = this.form2.data[i];
                if (i == 'AC_EMAIL') {
                    item.change = (data) => {
                        this.form2Check(i);
                        this.FunctionToken(this.FunctionGetMail, {
                            AC_EMAIL: data.val,
                            JSval: { email: true },
                        });
                    };
                } else {
                    item.change = () => {
                        this.form2Check(i);
                    };
                }
            }

            for (let i in this.form3.data) {
                let item = this.form3.data[i];
                item.keypress = (event) => {
                    if (event.charCode === 13) {
                        this.form3Save();
                    }
                };

                item.change = () => {
                    this.form3Check(i);
                };
            }
        },
        form1Keyup(event) {
            if (event.charCode === 13) {
                this.form1Save();
            }
        },
        form2Keyup(event) {
            if (event.charCode === 13) {
                this.form2Save();
            }
        },

        form1Clear() {
            for (let i in this.form1.data) {
                let item = this.form1.data[i];
                item.val = '';
                item.msg = '';
                item.keypress = this.form1Keyup;
            }

            this.form1.data['CodePass'].img = { Code: '', Image: '' };
            this.FunctionToken(this.FunctionGetImageCode, {
                JSval: { type: 'form1' },
            });
        },
        form2Clear() {
            for (let i in this.form2.data) {
                let item = this.form2.data[i];
                if (i == 'if1') {
                    item.val = false;
                } else {
                    item.val = '';
                    item.msg = '';
                    item.keypress = this.form2Keyup;
                    item.only = false;
                }
            }
        },
        form1Check(id) {
            let msg = '';
            if (id == 'Id') {
                this.form1.data['Id'].msg = '';
                if (this.IsNull(this.form1.data['Id'].val) == '') {
                    msg += '未填寫帳號／電子郵件\n';
                    this.form1.data['Id'].msg = {
                        type: false,
                        texts: ['未填寫帳號／電子郵件'],
                    };
                }
            } else if (id == 'DecryptionPass') {
                this.form1.data['DecryptionPass'].msg = '';
                if (this.IsNull(this.form1.data['DecryptionPass'].val) == '') {
                    msg += '未填寫密碼\n';
                    this.form1.data['DecryptionPass'].msg = {
                        type: false,
                        texts: ['未填寫密碼'],
                    };
                }
            } else if (id == 'CodePass') {
                this.form1.data['CodePass'].msg = '';
                if (this.IsNull(this.form1.data['CodePass'].val) == '') {
                    msg += '未填寫驗證碼\n';
                    this.form1.data['CodePass'].msg = {
                        type: false,
                        texts: ['未填寫驗證碼'],
                    };
                }
            }
            if (id == 'CodePass') {
                this.form2.data['CodePass'].msg = '';
                if (this.IsNull(this.form2.data['CodePass'].val) == '') {
                    msg += '未填寫驗證碼\n';
                    this.form2.data['CodePass'].msg = {
                        type: false,
                        texts: ['未填寫驗證碼'],
                    };
                }
            }
            return msg;
        },

        form2Check(id) {
            let msg = '';
            if (id == 'AC_USERNAME') {
                this.form2.data['AC_USERNAME'].msg = '';
                if (this.IsNull(this.form2.data['AC_USERNAME'].val) == '') {
                    msg += '未填寫姓名\n';
                    this.form2.data['AC_USERNAME'].msg = {
                        type: false,
                        texts: ['未填寫姓名'],
                    };
                }
            } else if (id == 'AC_EMAIL') {
                this.form2.data['AC_EMAIL'].msg = '';
                if (this.IsNull(this.form2.data['AC_EMAIL'].val) == '') {
                    msg += '未填寫電子郵件\n';
                    this.form2.data['AC_EMAIL'].msg = {
                        type: false,
                        texts: ['未填寫電子郵件'],
                    };
                } else if (this.VerifyModel()['email'](this.form2.data['AC_EMAIL'].val) == false) {
                    msg += '電子郵件格式不符\n';
                    this.form2.data['AC_EMAIL'].msg = {
                        type: false,
                        texts: ['電子郵件格式不符'],
                    };
                }
            } else if (id == 'AC_TEL') {
                this.form2.data['AC_TEL'].msg = '';
                if (this.IsNull(this.form2.data['AC_TEL'].val) == '') {
                    msg += '未填寫行動電話\n';
                    this.form2.data['AC_TEL'].msg = {
                        type: false,
                        texts: ['未填寫行動電話'],
                    };
                } else if (this.VerifyModel()['phone'](this.form2.data['AC_TEL'].val) == false) {
                    msg += '行動電話格式不符\n';
                    this.form2.data['AC_TEL'].msg = {
                        type: false,
                        texts: ['行動電話格式不符'],
                    };
                }
            } else if (id == 'AC_PWD') {
                this.form2.data['AC_PWD'].msg = '';
                if (this.IsNull(this.form2.data['AC_PWD'].val) == '') {
                    msg += '未填寫密碼\n';
                    this.form2.data['AC_PWD'].msg = {
                        type: false,
                        texts: ['未填寫密碼'],
                    };
                }
            } else if (id == 'AC_PWD2') {
                this.form2.data['AC_PWD2'].msg = '';
                if (this.IsNull(this.form2.data['AC_PWD2'].val) == '') {
                    msg += '未填寫確認密碼\n';
                    this.form2.data['AC_PWD2'].msg = {
                        type: false,
                        texts: ['未填寫確認密碼'],
                    };
                } else if (
                    this.IsNull(this.form2.data['AC_PWD'].val) != '' &&
                    this.form2.data['AC_PWD'].val != this.form2.data['AC_PWD2'].val
                ) {
                    msg += '密碼與確認密碼不符\n';
                    this.form2.data['AC_PWD2'].msg = {
                        type: false,
                        texts: ['密碼與確認密碼不符'],
                    };
                }
            }
            return msg;
        },

        form1Show() {
            // if (this.IsNull(this._sessionData('TokenID')) != '') {
            //     this.form1Go();
            //     return;
            // }
            for (let i in this.form1.data) {
                this.form1.data[i].val = '';
            }
            this.resetMemberTwoFactorState();
            // this.form1Clear();
            // this.form2Clear();
            // this.form1.show = true;
            // this.form2.show = false;
            apiCheckMember()
                .then(() => {
                    // this.AddCart();
                    this._go('./order');
                })
                .catch(() => {
                    this.FunctionGetImageCode();
                    this.modal['form1'].show();
                });
        },
        form2Show() {
            for (let i in this.form2.data) {
                this.form2.data[i].val = '';
            }
            this.form1.show = false;
            this.form2.show = true;
        },

        form1Save() {
            if (this.form1.twoFactorPending) {
                if (this.form1.otpExpired) {
                    alert('Email 驗證碼已過期');
                    return;
                }
                this.form1VerifyTwoFactor();
                return;
            }
            // let msg = '';
            // for (let i in this.form1.data) {
            //     msg += this.form1Check(i);
            // }
            // if (msg != '') {
            //     this.Clog(msg);
            //     alert('尚有錯誤未修復');
            //     return;
            // }

            let json1 = {};
            for (let i in this.form1.data) {
                json1[i] = this.form1.data[i].val;
            }
            json1['DecryptionCodePass'] = this.form1.data['CodePass'].img.Code;
            this.Clog(json1);
            console.log(this.form1.data);
            this.FunctionLogin(json1);
        },
        form1ResendTwoFactor() {
            if (!this.form1.twoFactorPending) {
                return;
            }

            this.form1.isResendingOtp = true;
            apiResendMemberTwoFactorLogin({
                TwoFactorToken: this.form1.twoFactorToken,
            })
                .then((res) => {
                    this.form1.twoFactorToken = res.data.TwoFactorToken || '';
                    this.form1.data['OtpCode'].val = '';
                    this.startMemberOtpCountdown(res.data.OtpExpireMinutes || 5);
                    alert('已重新發送 Email 驗證碼');
                })
                .catch((err) => {
                    const message =
                        err?.response?.data?.message || err?.response?.data?.error || err?.response?.data;
                    if (message) {
                        return alert(message);
                    }
                    console.log(err);
                    alert('重新發送驗證碼失敗');
                })
                .finally(() => {
                    this.form1.isResendingOtp = false;
                });
        },
        form1VerifyTwoFactor() {
            const otpCode = this.IsNull(this.form1.data['OtpCode'].val);
            if (otpCode == '') {
                alert('請輸入 Email 驗證碼');
                return;
            }

            this.form1.isVerifyingOtp = true;
            apiVerifyMemberTwoFactorLogin({
                TwoFactorToken: this.form1.twoFactorToken,
                OtpCode: otpCode,
            })
                .then((res) => {
                    this.completeMemberLogin(res);
                })
                .catch((err) => {
                    const message =
                        err?.response?.data?.message || err?.response?.data?.error || err?.response?.data;
                    if (message) {
                        return alert(message);
                    }
                    console.log(err);
                    alert('驗證失敗');
                })
                .finally(() => {
                    this.form1.isVerifyingOtp = false;
                });
        },
        resetMemberTwoFactorState() {
            this.stopMemberOtpCountdown();
            this.form1.twoFactorPending = false;
            this.form1.twoFactorToken = '';
            this.form1.otpExpireMinutes = 5;
            this.form1.otpRemainingSeconds = 0;
            this.form1.otpCountdownText = '05:00';
            this.form1.otpExpired = false;
            this.form1.isSubmitting = false;
            this.form1.isVerifyingOtp = false;
            this.form1.isResendingOtp = false;
            this.form1.data['OtpCode'].val = '';
        },
        completeMemberLogin(res) {
            localStorage.setItem('TokenID', res.data.TokenId);
            localStorage.setItem('NewToken', res.data.Token);
            sessionStorage.removeItem('memberNotificationSummaryShown');
            this.resetMemberTwoFactorState();
            this.modal['form1'].hide();
            this.$router.push({ path: '/myRegistration' });
        },
        formatOtpCountdown(totalSeconds) {
            const safeSeconds = Math.max(0, Number(totalSeconds) || 0);
            const minutes = String(Math.floor(safeSeconds / 60)).padStart(2, '0');
            const seconds = String(safeSeconds % 60).padStart(2, '0');
            return `${minutes}:${seconds}`;
        },
        stopMemberOtpCountdown() {
            if (this.memberOtpCountdownTimer) {
                clearInterval(this.memberOtpCountdownTimer);
                this.memberOtpCountdownTimer = null;
            }
        },
        startMemberOtpCountdown(minutes) {
            const totalSeconds = Math.max(0, (Number(minutes) || 0) * 60);
            this.stopMemberOtpCountdown();
            this.form1.otpExpireMinutes = Number(minutes) || 5;
            this.form1.otpRemainingSeconds = totalSeconds;
            this.form1.otpCountdownText = this.formatOtpCountdown(totalSeconds);
            this.form1.otpExpired = totalSeconds <= 0;

            if (totalSeconds <= 0) {
                return;
            }

            this.memberOtpCountdownTimer = setInterval(() => {
                if (this.form1.otpRemainingSeconds <= 1) {
                    this.form1.otpRemainingSeconds = 0;
                    this.form1.otpCountdownText = '00:00';
                    this.form1.otpExpired = true;
                    this.stopMemberOtpCountdown();
                    return;
                }

                this.form1.otpRemainingSeconds -= 1;
                this.form1.otpCountdownText = this.formatOtpCountdown(this.form1.otpRemainingSeconds);
            }, 1000);
        },
        form2Save() {
            let msg = '';
            for (let i in this.form2.data) {
                msg += this.form2Check(i);
            }
            if (msg != '') {
                this.Clog(msg);
                // alert('尚有錯誤未修復');
                return;
            }

            if (this.form2.data['if1'].val == false) {
                alert('未同意 個資保護政策');
                return;
            }

            let json1 = {};
            for (let i in this.form2.data) {
                if (i == 'AC_PWD2' || i == 'if1') {
                    continue;
                }

                json1[i] = this.form2.data[i].val;
            }
            json1['AC_USERID'] = this.form2.data['AC_EMAIL'].val;
            json1['AC_BIRTHDAY'] = '1911/01/01';
            json1['AC_IDNUM'] = this.form2.data['AC_USERID'].val;
            this.Clog(json1);
            console.log(json1);
            this.FunctionACCOUNTInsertByIndex(json1);
        },
        form1Go() {
            if (this.IsNull(this._sessionData('TokenID')) == '') {
                alert('尚未登入');
                return;
            }

            this.modal['form1'].hide();
            this._go('member');
        },
        form1Login(type) {
            if (type == 'google') {
                this.Clog('google');
                this.LoginData['google'].login((data) => {
                    this.Clog(data);
                    this.Clog(data.getId());
                    let Auth = data.getAuthResponse(true);
                    this.Clog(Auth);
                    this.Clog(Auth.id_token);
                    this.LoginData['google'].get((data) => {
                        if (this.IsNull(data.body) != '') {
                            let data1 = JSON.parse(data.body);
                            this.Clog(data1);

                            if (this.IsNull(data1.emailAddresses) != '' && data1.emailAddresses.length != 0) {
                                let email = this.IsNull(data1.emailAddresses[0].value);
                                this.Clog(email);
                                if (this.IsNull(email) != '') {
                                    this.FunctionToken(this.FunctionMailLogin, {
                                        TYPE: 'GOOGLE',
                                        ID: Auth.id_token,
                                        AC_EMAIL: email,
                                    });
                                }
                            }
                        }
                    });
                });
            } else if (type == 'fb') {
                this.LoginData['fb'].login((data) => {
                    this.Clog(data);
                    this.LoginData['fb'].check((data) => {
                        let data1 = this.IsNull(data.authResponse);
                        this.Clog(data1.accessToken);
                        this.FunctionToken(this.FunctionMailLogin2, {
                            TYPE: 'FB',
                            ID: data1.accessToken,
                        });
                        //this.FunctionTEST2({id:data1.accessToken})
                    });
                    this.LoginData['fb'].get((data) => {
                        this.Clog(data);
                    });
                });
            }
        },

        form3Keyup(event) {
            if (event.charCode === 13) {
                this.form3Save();
            }
        },

        form3Clear() {
            for (let i in this.form3.data) {
                let item = this.form3.data[i];
                item.val = '';
                item.msg = '';
            }
        },
        form3Check(id) {
            let msg = '';

            if (id == 'AC_EMAIL') {
                this.form3.data['AC_EMAIL'].msg = '';
                if (this.IsNull(this.form3.data['AC_EMAIL'].val) == '') {
                    msg += '未填寫電子郵件\n';
                    this.form3.data['AC_EMAIL'].msg = {
                        type: false,
                        texts: ['未填寫電子郵件'],
                    };
                }
            }
            return msg;
        },

        form3Show() {
            this.form3.data['Id'].val = '';
            this.form3.data['AC_EMAIL'].val = '';
            this.modal['form1'].hide();
            this.modal['form3'].show();
        },
        form3Save() {
            let msg = '';
            for (let i in this.form3.data) {
                msg += this.form3Check(i);
            }
            if (msg != '') {
                console.log(msg);
                alert('尚有錯誤未修正');
                return;
            }

            this.FunctionToken(this.FunctionLastPass, {
                AC_USERID: this.form3.data['AC_EMAIL'].val,
                AC_EMAIL: this.form3.data['AC_EMAIL'].val,
            });
        },

        handleScroll() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            //console.log(scrollTop); //页面滚动距离
            if (scrollTop > 50) {
                this.isMin = true;
            } else {
                this.isMin = false;
            }
        },
        //================================================================
        //api
        FunctionGetImageCode() {
            apiGetCaptcha()
                .then((res) => {
                    if (this.imageCode) {
                        URL.revokeObjectURL(this.imageCode);
                    }
                    const imageUrl = URL.createObjectURL(res.data);
                    this.form1.data['CodePass'].img.Image = imageUrl;
                    this.form2.data['CodePass'].img.Image = imageUrl;
                    this.imageCode = imageUrl;
                    this.loadSet.show = false;
                })
                .catch((error) => {
                    this.loadSet.show = false;
                    console.log(error.response);
                });
            console.log(axios);
            // axios
            //     .get('https://demo.artinuro.com/Extension/api/Captcha', { responseType: 'blob' })
            //     .then((response) => {
            //         console.log(URL.createObjectURL(response.data));
            //         this.form1.data['CodePass'].img.Image = URL.createObjectURL(response.data);
            //         this.imageCode = URL.createObjectURL(response.data);
            //         this.loadSet.show = false;
            //     })
            //     .catch((error) => {
            //         this.loadSet.show = false;
            //         console.log(error.response);
            //     });
        },
        FunctionLogin(data_in) {
            var item = {
                Account: data_in.Id,
                Password: data_in.DecryptionPass,
                Captcha: data_in.CodePass,
            };
            this.form1.isSubmitting = true;
            apiLogin(item)
                .then((res) => {
                    if (res?.data?.RequiresTwoFactor) {
                        this.form1.twoFactorPending = true;
                        this.form1.twoFactorToken = res.data.TwoFactorToken || '';
                        this.form1.data['OtpCode'].val = '';
                        this.startMemberOtpCountdown(res.data.OtpExpireMinutes || 5);
                        return;
                    }

                    this.completeMemberLogin(res);
                })
                .catch((err) => {
                    this.FunctionGetImageCode();
                    this.resetMemberTwoFactorState();
                    const message =
                        err?.response?.data?.message || err?.response?.data?.error || err?.response?.data;
                    if (message) {
                        return alert(message);
                    }
                    console.log(err);
                    alert('登入失敗');
                })
                .finally(() => {
                    this.form1.isSubmitting = false;
                });
        },
        validateRegisterPassword(password, account) {
            if (!password) {
                return '未填寫密碼';
            }
            if (password.length < 12) {
                return '密碼長度至少需 12 碼';
            }
            if (!/[A-Z]/.test(password)) {
                return '密碼至少需包含一個大寫英文字母';
            }
            if (!/[a-z]/.test(password)) {
                return '密碼至少需包含一個小寫英文字母';
            }
            if (!/[0-9]/.test(password)) {
                return '密碼至少需包含一個數字';
            }
            if (!/[^A-Za-z0-9]/.test(password)) {
                return '密碼至少需包含一個特殊字元';
            }
            if (account && password.toLowerCase().includes(String(account).toLowerCase())) {
                return '密碼不可包含帳號';
            }
            return '';
        },
        FunctionACCOUNTInsertByIndex(data_in) {
            console.log(data_in);
            const passwordError = this.validateRegisterPassword(data_in.AC_PWD, data_in.AC_EMAIL);
            if (passwordError) {
                alert(passwordError);
                return;
            }
            var item = {
                Id: this.$newGuid(),
                Account: data_in.AC_EMAIL,
                Password: data_in.AC_PWD,
                PasswordConfirm: data_in.AC_PWD,
                FirstName: data_in.AC_USERNAME,
                Captcha: data_in.CodePass,
            };
            apiRegister(item).then((res) => {
                alert('註冊成功!\n請至信箱進行驗證，再進行登入，謝謝');
                this.resetAuthModalState();
                this.modal['form1'].hide();
                console.log(res);
            }).catch((err) => {
                this.FunctionGetImageCode();
                const message =
                    err?.response?.data?.message || err?.response?.data?.error || err?.response?.data;
                if (message) {
                    return alert(message);
                }
                console.log(err);
            });
            // this.apiACCOUNTInsertByIndex(data_in)
            //     .then((res) => {
            //         let json = JSON.parse(res.data);
            //         this.Clog(json);
            //         if (json.Status) {
            //             alert('註冊成功');
            //             return;
            //         } else {
            //             alert('註冊失敗,' + json.Data);
            //             return;
            //         }
            //     })
            //     .catch((err) => {
            //         this.Elog(err);
            //         alert('註冊失敗');
            //     });
        },

        FunctionGetMail(data_in) {
            this.apiGetMail(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (this.IsNullKeys(data_in, ['JSval', 'email']) != '') {
                        if (json.Status == false) {
                            alert('信箱已註冊，請重新填寫');
                            this.form2.data['AC_EMAIL'].val = '';
                            this.form2.data['AC_EMAIL'].change(this.form2.data['AC_EMAIL']);
                        }
                    } else if (this.IsNullKeys(data_in, ['JSval', 'login']) != '') {
                        if (json.Status == true) {
                            alert(`此信箱(${data_in.AC_EMAIL})，尚未註冊`);
                            this.form2Clear();
                            this.form2.data['AC_EMAIL'].val = data_in.AC_EMAIL;
                            this.form2Show();
                        } else {
                            this.FunctionToken(this.FunctionMailLogin, {
                                AC_EMAIL: data_in.AC_EMAIL,
                            });
                        }
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },
        FunctionMailLogin(data_in) {
            let fun1 = this._storeData('LoginFUN');
            this.apiMailLogin(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        this._sessionData('TokenID', data1);
                        this.modal['form1'].hide();
                        this.form1.text = '學員資料';
                        this.refreshCartCounts();
                        if (this.IsNull(fun1) != '') {
                            fun1(this.$route.path, () => {
                                this._go('/myRegistration');
                            });
                        } else {
                            this._go('/myRegistration');
                        }
                    } else {
                        this.FunctionToken(this.FunctionGetImageCode, {
                            JSval: { type: 'form1' },
                        });
                        if (json.Data.indexOf('尚未註冊') != -1) {
                            alert(json.Data);
                            this.form2Clear();
                            this.form2.data['AC_EMAIL'].val = json.Data.split('，')[1];
                            this.form2Show();
                        } else {
                            alert('登入失敗');
                        }
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },
        FunctionMailLogin2(data_in) {
            let fun1 = this._storeData('LoginFUN');
            this.apiMailLogin2(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        this._sessionData('TokenID', data1);
                        this.modal['form1'].hide();
                        this.form1.text = '學員資料';
                        this.refreshCartCounts();
                        if (this.IsNull(fun1) != '') {
                            fun1(this.$route.path, () => {
                                this._go('/myRegistration');
                            });
                        } else {
                            this._go('/myRegistration');
                        }
                    } else {
                        this.FunctionToken(this.FunctionGetImageCode, {
                            JSval: { type: 'form1' },
                        });
                        if (json.Data.indexOf('尚未註冊') != -1) {
                            alert(json.Data);
                            this.form2Clear();
                            this.form2.data['AC_EMAIL'].val = json.Data.split('，')[1];
                            this.form2Show();
                        } else {
                            alert('登入失敗');
                        }
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },
        FunctionLastPass(data_in) {
            this.apiLastPass(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        alert('寄送成功');
                        this.modal['form3'].hide();
                    } else {
                        alert('寄送失敗');
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                    alert('寄送失敗');
                });
        },
        FunctionGetCategoryListByIndex(data_in) {
            this.apiGetCategoryListByIndex(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        let data2 = [];

                        let files = [];
                        for (let i in data1) {
                            let item = data1[i];
                            data2.push(item);
                            if (this.IsNull(item.CAT_ICON_URL) != '') {
                                files.push(item.CAT_ICON_URL);
                            }
                        }
                        this.CategoryData = data2;

                        if (files.length != 0) {
                            this.FunctionToken(this.FunctionGetArchive, {
                                MC_ID: files,
                            });
                        }
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },
        FunctionGetArchive(data_in) {
            this.apiGetArchive(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        let MCIDs = [];
                        for (let i in data1) {
                            let item = data1[i];
                            this.files[item.MC_ID] = encodeURI([item.SP_PATH_WEB, item.MC_FILE].join(''));
                            MCIDs.push(item.MC_ID);
                        }
                        this._watcher.run();
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },

        FunctionGetHashtgList(data_in) {
            this.apiGetHashtgList(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        data1.forEach((x) => {
                            this.nav.options.push(this.IsNull(x.HT_NAME));
                        });
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },

        FunctionGetCourseFeriodListByIndex_mini(data_in) {
            this.apiGetCourseFeriodListByIndex_mini(data_in)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let data1 = JSON.parse(json.Data);
                        data1.forEach((x) => {
                            if (this.IsNull(x.CA_HASHTAG_ID) === '') {
                                return;
                            }

                            let hashs = x.CA_HASHTAG_ID.split(',');
                            hashs.forEach((s) => {
                                if (this.nav.options.indexOf(s) == -1) {
                                    this.nav.options.push(s);
                                }
                            });
                        });
                    }
                })
                .catch((err) => {
                    this.Elog(err);
                });
        },
        refreshCartCounts() {
            const tokenId = this.IsNull(this._sessionData('TokenID'));
            if (tokenId == '') {
                this.cartSessionKey = '';
                this.$store.commit('campCart/setLoaded', false);
                this.$store.commit('courseCart/setLoaded', false);
                return;
            }

            const sessionKey = this.IsNull(this._sessionData('NewToken'), tokenId);
            if (this.cartSessionKey !== sessionKey) {
                this.cartSessionKey = sessionKey;
                this.$store.commit('campCart/setLoaded', false);
                this.$store.commit('courseCart/setLoaded', false);
            }

            this.$store.dispatch('campCart/fetchCart');
            this.$store.dispatch('courseCart/fetchCount');
        },
    },
    watch: {
        '$route.query.keywords'(val) {
            this.keywords = val || '';
        },
        '$route.path'() {
            this.refreshCartCounts();
        },
    }
};
</script>
<style lang="scss" scoped>
.form-inline input {
    border-radius: 50px;
}
.hot-tags-list {
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-end;
    gap: 0.75rem;
    max-width: 100%;
}
.hot-tag-button {
    font-size: 14px;
    font-weight: bolder;
    text-wrap: nowrap;
    background: #ffffff;
    color: var(--primary);
    border: none;
}
.camp-cart-badge {
    position: absolute;
    top: -2px;
    right: 8px;
    pointer-events: none;
    font-size: 11px;
    line-height: 1;
    padding: 0.3em 0.5em;
}
@media (max-width: 575.98px) {
    .logo {
        padding-right: 0.75rem !important;
        padding-left: 0.5rem !important;
    }
    .logo img {
        height: 28px !important;
    }
    .mobile-camp-button {
        padding: 0.375rem 0.625rem;
        white-space: nowrap;
    }
}
</style>
